const SellerFaqContent = [
  {
    title: "What is Lighter Advisory?",
    content:
      "Lighter Advisory is a real estate advisory primarily focused on creating a delightful customer experience. We walk with you through the entire journey of finding, exploring and buying or renting the perfect property as per your needs.",
  },
  {
    title: "Why Lighter Advisory?",
    content:
      "Lighter Advisory connects real estate clients by creating a powerful professional network. We leverage our connections with real estate experts, strategist, developers, agents and professionals to simplify real estate transactions. We tap the power of tools like social media, digital marketing, portals and community to maximize the reach of your properties.",
  },
  {
    title:
      "How can I buy a paid property advertisement on Lighter Advisory.com?",
    content:
      "You can call or WhatsApp us at +91 99807 75599 or mail us at mail@Lighter Advisory.com for a personalised advertising plan.",
  },
  {
    title: "How can I get my property verified on Lighter Advisory?",
    content:
      "Place a request with us for property verification, and our executives will get in touch with you and visit the property.",
  },
];

export default SellerFaqContent;
